export default __webpack_public_path__ + "assets/cc4eda114da0e9d5174acdb0adb6388c.svg";